import type { Language } from '@/bindings/Language'

/** Registry order mirrors the backend's `Language::ALL`: `en` first, also the "any filled" tiebreak. */
export const LANGUAGES: readonly Language[] = ['en', 'vi']
export const DEFAULT_LANGUAGE: Language = 'en'

export const LANGUAGE_NAMES: Record<Language, string> = { en: 'English', vi: 'Tiếng Việt' }

const STORAGE_KEY = 'romi.lang'

export function isLanguage(value: unknown): value is Language {
  return typeof value === 'string' && (LANGUAGES as readonly string[]).includes(value)
}

/** `vi-VN` → `vi`; the first supported primary subtag wins, else nothing. */
export function detectBrowserLanguage(tags: readonly string[] = navigator.languages ?? []): Language | undefined {
  for (const tag of tags) {
    const primary = tag.toLowerCase().split('-')[0]
    if (isLanguage(primary)) return primary
  }
  return undefined
}

export function readStoredLanguage(): Language | undefined {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    return isLanguage(value) ? value : undefined
  } catch {
    return undefined
  }
}

export function writeStoredLanguage(language: Language) {
  try {
    localStorage.setItem(STORAGE_KEY, language)
  } catch {
    // Storage blocked (private mode, quota): the choice lives for this page only.
  }
}

/** T4.7 first visit: stored choice → browser language if supported → English. */
export function initialLanguage(): Language {
  return readStoredLanguage() ?? detectBrowserLanguage() ?? DEFAULT_LANGUAGE
}
